
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"currentColor"}},[_c('path',{attrs:{"d":"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3C12.402 45 3 35.598 3 24S12.402 3 24 3s21 9.402 21 21-9.402 21-21 21z"}}),_c('path',{attrs:{"d":"M9.587 34.497C11.92 27.93 17.57 23.5 24 23.5c6.43 0 12.08 4.43 14.413 10.997a1.5 1.5 0 01-2.826 1.005C33.66 30.078 29.096 26.5 24 26.5s-9.66 3.578-11.587 9.002a1.5 1.5 0 01-2.826-1.005zM35.737 13.028a1.5 1.5 0 00-2.185-2.056l-5.645 6c-.9.958-.221 2.528 1.093 2.528h7.517a1.5 1.5 0 100-3H32.47l3.266-3.472zM16.043 16.5l-3.266-3.472a1.5 1.5 0 012.185-2.056l5.644 6c.9.958.222 2.528-1.092 2.528h-7.517a1.5 1.5 0 110-3h4.046z"}})])])
          )
        }
      }
    